import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { deliveryClient } from '../../lib/connect/clients';
// Phase 5c — the signed-in user's delivery notification inbox. ryugu resolves
// the recipient server-side from the gateway principal (the request never names
// a user) and projects per program, so a notification whose source program the
// recipient can no longer see is suppressed and disclosed as hidden_count
// (DRIFT-2) — being the routed owner does not bypass NoView.
const KEY = 'delivery-notifications';
export function useMyNotifications(companyId) {
    return useQuery({
        queryKey: [
            KEY,
            companyId
        ],
        queryFn: async ()=>{
            const resp = await deliveryClient.listMyNotifications({
                companyId,
                unacknowledgedOnly: false
            });
            return {
                notifications: resp.notifications,
                hiddenCount: resp.hiddenCount
            };
        },
        enabled: !!companyId,
        staleTime: 30000
    });
}
export function useAcknowledgeNotification(companyId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (recipientId)=>deliveryClient.acknowledgeNotification({
                companyId,
                recipientId
            }),
        onSuccess: ()=>{
            qc.invalidateQueries({
                queryKey: [
                    KEY,
                    companyId
                ]
            });
        }
    });
}
export function useAcknowledgeAllNotifications(companyId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ()=>deliveryClient.acknowledgeAllNotifications({
                companyId
            }),
        onSuccess: ()=>{
            qc.invalidateQueries({
                queryKey: [
                    KEY,
                    companyId
                ]
            });
        }
    });
}
